// extracted by mini-css-extract-plugin
export default {"table_color":"MonthHashRate_table_color__EetYW","month_hash_rate_tr":"MonthHashRate_month_hash_rate_tr__siRWZ"};